export * from './reservation.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/reservation/index.ts